import React from 'react';
import { DownloadButton } from '../../../ui-kit';
import { downloadRoccoList, type RoccoList } from '../../../services/roccoService';

/**
 * The Download control on an agent's lists: Excel, with every record rather
 * than the page on screen, as the dashboards' record lists do. ROCCO's lists
 * pass `list`; any other agent passes its own `download`.
 */
export default function ListDownload({
  list, download, total, noun,
}: { list?: RoccoList; download?: () => Promise<unknown>; total: number; noun: string }) {
  const [busy, setBusy] = React.useState(false);
  const [problem, setProblem] = React.useState<string | null>(null);
  return (
    <DownloadButton
      formats={[{
        key: 'xlsx',
        label: 'Excel (.xlsx)',
        description: `Every one of the ${total.toLocaleString()} ${noun}, not only those on screen`,
        onDownload: async () => {
          setBusy(true);
          setProblem(null);
          try {
            await (download ? download() : downloadRoccoList(list as RoccoList));
          } catch (err) {
            setProblem(err instanceof Error ? err.message : 'Could not download');
          } finally {
            setBusy(false);
          }
        },
      }]}
      tooltip={problem || `Download every ${noun.replace(/s$/, '')} as Excel`}
      loading={busy}
    />
  );
}
